import { Event, Shift, ShiftType } from '@amzn/red-velvet-api';
import { isUnlistedEvent } from './eventUtils';

export function isUnsupportedSignup(event?: Event, shift?: Shift): boolean {
  return (
    (event !== undefined && isUnlistedEvent(event)) ||
    shift?.shiftType === ShiftType.WAITLIST ||
    shift?.shiftType === ShiftType.DROP_IN
  );
}
